declare namespace $ {

	export class $bog_fragile_demo_rename_base2 extends $mol_view {
		caption( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=base2.view.tree.d.ts.map